// src/components/WalletSelectModal.jsx
import React, { useEffect, useState } from "react";

export default function WalletSelectModal({ open, onClose, onWalletChosen }) {
  const [detected, setDetected] = useState([]);

  useEffect(() => {
    if (!open) return;

    const found = [];
    const added = {
      metamask: false,
      trust: false,
      brave: false,
      injected: false,
    };

    const eth = typeof window !== "undefined" ? window.ethereum : null;

    if (eth) {
      // some browsers/wallets expose multiple providers (metamask + something else)
      const providers = eth.providers || [eth];

      providers.forEach((p) => {
        // skip phantom completely
        if (p.isPhantom || p.isPhantomEthereum) return;

        if (p.isMetaMask && !added.metamask) {
          found.push({ id: "metamask", label: "MetaMask (detected)", provider: p });
          added.metamask = true;
          return;
        }

        if (p.isTrust && !added.trust) {
          found.push({ id: "trust", label: "Trust Wallet (detected)", provider: p });
          added.trust = true;
          return;
        }

        if (p.isBraveWallet && !added.brave) {
          found.push({ id: "brave", label: "Brave Wallet (detected)", provider: p });
          added.brave = true;
          return;
        }
      });

      // if we have ethereum but none of our preferred ones, fall back to a single generic injected
      if (!added.metamask && !added.trust && !added.brave && !added.injected) {
        found.push({ id: "injected", label: "Injected EVM Wallet", provider: eth });
        added.injected = true;
      }
    }

    // also skip window.phantom.ethereum explicitly
    // (we just don't add it at all)

    setDetected(found);
  }, [open]);

  if (!open) return null;

  const handleChoose = (wallet) => {
    onWalletChosen && onWalletChosen(wallet);
    onClose && onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
      <div className="bg-[#1a0d1d] border border-white/10 rounded-2xl max-w-md w-full p-6 shadow-2xl">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold text-white">Select a wallet</h3>
          <button
            onClick={onClose}
            className="text-white/50 hover:text-white text-2xl leading-none"
          >
            ×
          </button>
        </div>
        <p className="text-sm text-white/70 mb-4 text-left">
          We looked in your browser for EVM / BNB compatible wallets. Pick one, or use a DEX to
          buy STBOX when it’s live.
        </p>

        {/* Detected wallets */}
        {detected.length > 0 ? (
          <div className="flex flex-col gap-3 mb-4">
            {detected.map((w) => (
              <button
                key={w.id}
                onClick={() => handleChoose(w)}
                className="flex items-center justify-between bg-white/5 hover:bg-white/10 px-4 py-3 rounded-xl transition text-left text-white"
              >
                <span>{w.label}</span>
                <span className="text-white/30 text-xs">detected</span>
              </button>
            ))}
          </div>
        ) : (
          <div className="mb-4 text-white/40 text-sm">
            No BNB/EVM wallets detected. You can still use a DEX link below.
          </div>
        )}

        {/* Generic options */}
        <div className="flex flex-col gap-3 mb-4">
          <a
            href="https://pancakeswap.finance/swap"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between bg-white/5 hover:bg-white/10 px-4 py-3 rounded-xl transition text-white"
          >
            <span>Open PancakeSwap</span>
            <span className="text-white/40 text-xs">DEX</span>
          </a>
          <a
            href="https://bscscan.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between bg-white/5 hover:bg-white/10 px-4 py-3 rounded-xl transition text-white"
          >
            <span>View on BscScan (after launch)</span>
            <span className="text-white/40 text-xs">explorer</span>
          </a>
        </div>

        <p className="text-[11px] text-white/30 mt-4 text-left">
          We only show wallets that typically support BNB / EVM. Phantom and non-EVM wallets are
          hidden.
        </p>
      </div>
    </div>
  );
}
